import styled from "styled-components";

import { SIZES } from "./consts";
import { IconColor, IconSize } from "./types";
import { resolveColor } from "./utils";

export const StyledI = styled.i<{ $fontSize: IconSize; $color?: IconColor }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  line-height: 1;
  font-size: ${({ $fontSize }) => SIZES[$fontSize]};
  color: ${({ theme, $color }) => resolveColor(theme, $color)};
`;

export const StyledSvg = styled.svg<{ $fontSize: IconSize; $color?: IconColor }>`
  flex-shrink: 0;
  width: ${({ $fontSize }) => SIZES[$fontSize]};
  height: ${({ $fontSize }) => SIZES[$fontSize]};
  color: ${({ theme, $color }) => resolveColor(theme, $color)};
  fill: currentColor;

  /* The theme's global "body * { color }" also lands on the shapes inside an
     SVG. fill:currentColor is resolved per element against its own color, so
     those shapes would paint with the global text colour instead of the icon's.
     Restoring their inherited color makes currentColor resolve correctly. */
  & * {
    color: inherit;
    fill: currentColor;
  }
`;
